import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import service from '../services/service';
import InviteButton from '../containers/InviteButton';
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
export default {
  name: 'nearest-egg',
  components: {
    InviteButton: InviteButton
  },
  data: function data() {
    return {
      index: 0,
      friends: [],
      list: [],
      eggTypeClass: ['type_1', 'type_0', 'type_1', 'type_0']
    };
  },
  computed: _objectSpread({}, mapState(['isLogin']), mapGetters(['userInfo', 'eggInfo']), {
    nick: function nick() {
      return this.userInfo && this.userInfo.nick || '';
    },
    avatar: function avatar() {
      if (this.userInfo) {
        return this.userInfo.headurl;
      } else {
        return '//vm.gtimg.cn/tencentvideo/vstyle/newvip/style/h5/imgs/common/head_default.svg';
      }
    }
  }),
  methods: {
    changHandler: function changHandler() {
      var start = (this.index + 1) * 4;
      this.list = this.friends.slice(start, start + 4);

      if (this.list.length) {
        this.index++;
      } else {
        this.list = this.friends.slice(0, 4);
        this.index = 0;
      }

      this.fillFriends();
    },
    fillFriends: function fillFriends() {
      while (this.list.length < 4) {
        this.list.push({
          avatar: '//puui.qpic.cn/vupload/0/20190115_1547549735178_clqn1r0fzo.png/0'
        });
      }
    },
    shareHandler: function shareHandler() {
      this.$refs.inviteButton.shareHandler();
    }
  },
  created: function () {
    var _created = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (this.isLogin) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return service.getFriendship();

            case 4:
              res = _context.sent;

              if (res.ret === 0) {
                this.friends = res.data.ranklist.map(function (item) {
                  item.vipinfo.endTime = moment(item.vipinfo.endTime).format('YYYY-MM-DD HH:mm:ss');
                  item.vipinfo.beginTime = moment(item.vipinfo.beginTime).format('YYYY-MM-DD HH:mm:ss');
                  return item;
                });
              }

              this.list = this.friends.slice(0, 4);
              this.fillFriends();

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }()
};